import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import ThreeDotMenu from './ThreeDotMenu';
import { pushView } from './cardNavigationComponent/cardNavigationRedux';
// eslint-disable-next-line import/no-cycle
import TaskAssigneeCard from './taskAssigneeCard/TaskAssigneeCard';
import { removeAllAssigneeFromTask } from '../taskView/TaskViewPage/redux/actions';
import { isUnassignAllowed } from '../../HelperMethods/TaskUtilities';

function AssigneeThreeDotMenu({ task, container }) {
  const dispatch = useDispatch();
  const options = [
    {
      key: 'updateResources',
      text: 'Update Resources',
      onClick: () => {
        dispatch(pushView(container, { component: TaskAssigneeCard, props: { taskId: task.id } }));
      },
    },
  ];
  const canUnassign = isUnassignAllowed(task);
  if (canUnassign) {
    options.unshift({
      key: 'unassign',
      text: 'Unassign',
      onClick: () => {
        dispatch(removeAllAssigneeFromTask(task));
      },
    });
  }

  return <ThreeDotMenu options={options} />;
}
AssigneeThreeDotMenu.propTypes = {
  task: PropTypes.object.isRequired,
  container: PropTypes.string.isRequired,
};

export default AssigneeThreeDotMenu;
